import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  ADD_DATES,
  CHECK_IN,
  CHECK_OUT,
  CLEAR_BUTTON,
} from '../../../../config/text/text';
import { dateConvertProductToDoMmmyyyy } from '../../../../helpers/booking';
import ThemeContext from '../../../../providers/ThemeProvider';
import BookingCalendarButton from './BookingCalendarButton';

const BookingCalendarCheckInOut = ({
  beginEndDates,
  resetCalendar,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="dates-container">
        <span className="dates-checkin-item">
          <p className="dates-date-label">{CHECK_IN}</p>
          {beginEndDates?.checkInDate && (
            <p className="dates-date">
              {dateConvertProductToDoMmmyyyy(beginEndDates?.checkInDate)}
            </p>
          )}
          {!beginEndDates?.checkInDate && (
            <p className="dates-date">{ADD_DATES}</p>
          )}
        </span>
        <span
          className={classNames('dates-checkout-item', {
            'dates-checkout-item__grey': !beginEndDates?.checkInDate,
          })}
        >
          <p className="dates-date-label">{CHECK_OUT}</p>
          {beginEndDates?.checkOutDate && (
            <p className="dates-date">
              {dateConvertProductToDoMmmyyyy(beginEndDates?.checkOutDate)}
            </p>
          )}
          {!beginEndDates?.checkOutDate && (
            <p className="dates-date">{ADD_DATES}</p>
          )}
        </span>
        <span className="button-item">
          <BookingCalendarButton
            className="package-nav-button"
            onClick={resetCalendar}
            text={CLEAR_BUTTON}
          />
        </span>
      </div>
      <style jsx>{`
        .dates-container {
          background-color: ${theme.colors.primary};
          display: flex;
          padding: 5px 15px;
        }
        .dates-checkin-item {
          background-color: ${theme.commoncolors.white};
          border-radius: 4px;
          margin: 0 15px 0 0;
          padding: 4px 0;
          text-align: center;
          width: 35%;
        }
        .dates-checkout-item {
          background-color: ${theme.commoncolors.white};
          border-radius: 4px;
          margin: 0 15px 0 0;
          padding: 4px 0;
          text-align: center;
          width: 35%;
        }
        .dates-checkout-item__grey {
          color: ${theme.commoncolors.darkgrey};
          width: 35%;
        }
        .button-item {
          flex-grow: 1;
          margin: 0;
        }
        .dates-date {
          font-size: 15px;
          margin-bottom: 0;
        }
        .dates-date-label {
          font-size: 13px;
          font-weight: bold;
          margin-bottom: 0;
        }
      `}</style>
    </>
  );
};

BookingCalendarCheckInOut.propTypes = {
  beginEndDates: PropTypes.object,
  resetCalendar: PropTypes.func,
};

BookingCalendarCheckInOut.defaultProps = {
  beginEndDates: null,
};

export default BookingCalendarCheckInOut;
